export enum CalculStatusEnum {
  WAITING_FOR_MORPHOLOGY = "WAITING_FOR_MORPHOLOGY",
  WAITING_FOR_CONFIGURATION = "WAITING_FOR_CONFIGURATION",
  CALCUL_IN_PROGRESS = "CALCUL_IN_PROGRESS",
  READY = "READY",
}

export function calculStatusToLabel(status: CalculStatusEnum | undefined): string {
  switch (status) {
    case CalculStatusEnum.WAITING_FOR_MORPHOLOGY:
      return "En attente de définition de la morphologie"
    case CalculStatusEnum.WAITING_FOR_CONFIGURATION:
      return "En cours de configuration"
    case CalculStatusEnum.CALCUL_IN_PROGRESS:
      return "En cours de calcul"
    case CalculStatusEnum.READY:
      return "Résultat à jour"
    default:
      return ""
  }
}
